// tslint:disable
/**
 * JLIVE ADMIN API
 * JLIVE ADMIN API
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface OrderDonation
 */
export interface OrderDonation {
  /**
   * @type {number}
   * @memberof OrderDonation
   */
  readonly id?: number;
  /**
   * @type {number}
   * @memberof OrderDonation
   */
  charged_amount?: number;
  /**
   * @type {string}
   * @memberof OrderDonation
   */
  charged_currency?: OrderDonationChargedCurrencyEnum;
  /**
   * @type {string}
   * @memberof OrderDonation
   */
  on_behalf_of?: string;
  /**
   * @type {boolean}
   * @memberof OrderDonation
   */
  is_required?: boolean;
}

/**
 * @export
 * @enum {string}
 */
export enum OrderDonationChargedCurrencyEnum {
  Usd = 'usd',
  Cad = 'cad',
}
